import { render, staticRenderFns } from "./suggestsDialog.vue?vue&type=template&id=b131c9e8&"
import script from "./suggestsDialog.vue?vue&type=script&lang=js&"
export * from "./suggestsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports